// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "365452869baacd0e8c60e4e8bda287bc" + ".js";
};